<div class="loading-container">
  <div class="modern-loader"></div>
</div>
